import { Scaling } from "./Scaling";
import { Logger, Utils } from "neo-common";
import { GameManager } from "../Managers/GameManager";
import { Communication } from "neo-games";
import { Settings } from "../CustomComponents/Settings";

var GameStatuses = Communication.Game.GameModuleStatus;

/**
 * @class CustomUtils
 * @author Marek Turkovic
 */
export class CustomUtils {
    /**
     *
     * @param symbolId
     * @param caseName
     */
    public static getCase(symbolId: number, caseName: string): string {
        if (CustomUtils.isRespinActive() || CustomUtils.isRespinLast()) {
            if (
                GameManager.gambleResponse == null ||
                (GameManager.gambleResponse != null && GameManager.gambleResponse.status !== GameStatuses.Active)
            ) {
                switch (caseName) {
                    case "NOWIN":
                        caseName = symbolId == Settings.SymbolBigXSpins ? caseName : "NOWIN_BLANK";
                        break;
                    case "NORMAL":
                        caseName = symbolId == Settings.SymbolBigXSpins ? caseName : "BLANK";
                        break;
                    case "BLUR":
                        caseName = symbolId == Settings.SymbolBigXSpins ? caseName : "BLUR_BLANK";
                        break;
                    case "ROTATION":
                        caseName = symbolId == Settings.SymbolBigXSpins ? caseName : "ROTATION_BLANK";
                        break;
                }
            }
        }

        return caseName;
    }

    static isRespin(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0
        );
    }

    /**
     * Indicates that respin was triggered.
     * @returns {boolean}
     */
    static isRespinEnabled(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0 &&
            GameManager.baseResponse.spinId === 0
        );
    }

    /**
     * Indicates that respin is in progress.
     * @returns {boolean}
     */
    static isRespinActive(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0 &&
            GameManager.baseResponse.spinId > 0
        );
    }

    /**
     * Indicates that last respin round is in progress.
     * @returns {boolean}
     */
    static isRespinLast(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin === 0 &&
            GameManager.baseResponse.spinId > 0
        );
    }

    public static getBlendMode(blendMode: number): number {
        if (Scaling.IsIOs) {
            if (blendMode == 1) {
                blendMode = 3;
            }
        }

        return blendMode;
    }

    public static updateSpineData(spineData: JSON): JSON {
        if (Scaling.IsIOs) {
            if (spineData != null) {
                let spineTextData = JSON.stringify(spineData);
                spineTextData = spineTextData.split('"blend":"additive"').join('"blend":"screen"');
                spineData = JSON.parse(spineTextData);
            }
        }

        return spineData;
    }

    public static getObjectFrom(objName: string, source: any, tp?: any): any {
        if (source != null) {
            if (source[objName] != null) {
                if (tp != null) {
                    if (source[objName] instanceof tp) {
                        return source[objName];
                    } else {
                        if (DEBUG) {
                            CustomUtils.log("ERROR: " + objName + " has bad instance type");
                        }
                    }
                } else {
                    if (source[objName]) {
                        return source[objName];
                    }
                }
            } else {
                if (DEBUG) {
                    CustomUtils.log("ERROR: no " + objName);
                }
            }
        }

        return null;
    }

    /**
     *
     * @param win
     * @param i
     * @param j
     */
    public static isWinOnPosition(win: Communication.Game.IWin, i: number, j: number): boolean {
        if ((win.mask[i] & (1 << j)) !== 0) {
            return true;
        }

        return false;
    }

    /**
     * Sorts children of container by symbols position and zIndex attribute.
     */
    public static sortChildrenByZindex(holder: any): void {
        if (!Utils.isNullOrUndefined(holder)) {
            const children = holder.children;
            /*children.sort((a: any, b: any) => {
                a.x = a.x || 0;
                b.x = b.x || 0;
                return a.x - b.x; // ascending: a - b; descending b - a
            });

            children.sort((a: any, b: any) => {
                a.y = a.y || 0;
                b.y = b.y || 0;
                return b.y - a.y; // ascending: a - b; descending b - a
            });*/

            children.sort((a: any, b: any) => {
                if (a.hasOwnProperty("zIndex") && b.hasOwnProperty("zIndex")) {
                    a.zIndex = a.zIndex || 0;
                    b.zIndex = b.zIndex || 0;
                    return a.zIndex - b.zIndex; // ascending: a - b; descending b - a
                }
                return 0;
            });
        }
    }

    public static log(s: string): void {
        if (DEBUG) {
            let compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/CustomUtils.ts
 **/